import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import * as ac from "../actions/actions";
import type {
    IntentTopicRequestDto,
    SaveIntentTopicRequestDto,
    SaveIntentTopicResponseDto,
} from "app/pages/sales-intelligence/sub-modules/intent/types/dto";
import type { IntentApprovedTerms } from "app/pages/sales-intelligence/sub-modules/intent/types/common";

export const fetchIntentTopicsCategoryThunk = () => {
    return async function fetchIntentTopicsCategory(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchIntentCategories.request());

        try {
            const topicDescriptionDto = await deps.si.api.intent.fetchIntentTopicsDescription();
            return dispatch(ac.fetchIntentCategories.success(topicDescriptionDto));
        } catch (e) {
            return dispatch(ac.fetchIntentCategories.failure(e));
        }
    };
};

export const fetchSelectedIntentTopicsThunk = () => {
    return async function fetchSelectedIntentTopics(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchSelectedIntentTopics.request());

        try {
            const selectedIntentTopics = await deps.si.api.intent.fetchSelectedIntentTopic();
            return dispatch(ac.fetchSelectedIntentTopics.success(selectedIntentTopics));
        } catch (e) {
            return dispatch(ac.fetchSelectedIntentTopics.failure(e));
        }
    };
};

export const fetchIntentTopicsThunk = (dto: IntentTopicRequestDto) => {
    return async function fetchIntentTopics(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.fetchIntentTopics.request());

        try {
            const intentTopics = await deps.si.api.intent.fetchIntentTopics({
                ...dto,
                page: dto.page - 1,
            });
            return dispatch(ac.fetchIntentTopics.success(intentTopics));
        } catch (e) {
            return dispatch(ac.fetchIntentTopics.failure(e));
        }
    };
};

export const saveIntentTopicsThunk = (dto: SaveIntentTopicRequestDto) => {
    return async function saveIntentTopics(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.saveIntentTopics.request());

        try {
            const intentTopics: SaveIntentTopicResponseDto = await deps.si.api.intent.saveIntentTopics(dto);
            return dispatch(ac.saveIntentTopics.success(intentTopics));
        } catch (e) {
            dispatch(ac.saveIntentTopics.failure(e));
            return false;
        }
    };
};

export const fetchIntentManagementApprovalThunk = () => {
    return async function fetchIntentManagementApproval(
        dispatch: ThunkDispatchCommon,
        _: ThunkGetState,
        deps: ThunkDependencies,
    ) {
        dispatch(ac.fetchIntentManagementApproval.request());

        try {
            const intentApproval: IntentApprovedTerms = await deps.si.api.intent.fetchIntentApproval();
            return dispatch(ac.fetchIntentManagementApproval.success(intentApproval));
        } catch (e) {
            return dispatch(ac.fetchIntentManagementApproval.failure(e));
        }
    };
};

export const saveIntentManagementApprovalThunk = () => {
    return async function saveIntentTopics(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.saveIntentManagementApproval.request());

        try {
            const userApproval = await deps.si.api.intent.saveIntentUserApprovalTerms();
            return dispatch(ac.saveIntentManagementApproval.success());
        } catch (e) {
            return dispatch(ac.saveIntentManagementApproval.failure(e));
        }
    };
};

export const fetchIntentUserAdminsThunk = () => {
    return async function fetchIntentTopics(dispatch: ThunkDispatchCommon, _: ThunkGetState, deps: ThunkDependencies) {
        dispatch(ac.fetchIntentUserAdmins.request());

        try {
            const contactAdmins = await deps.si.api.intent.fetchIntentUserAdmins();
            return dispatch(ac.fetchIntentUserAdmins.success(contactAdmins));
        } catch (e) {
            return dispatch(ac.fetchIntentUserAdmins.failure(e));
        }
    };
};
